import React from 'react';
import { Button } from "baseui/button";
import PropTypes from 'prop-types'
import { Spinner, SIZE } from "baseui/spinner";
import './MobileScrollNotification.scss'

const MobileScrollNotification = ({ auth, btnLoading, onContinue, job_title }) => {
    return (
        <div className='mobile-notification'>
            {auth ? (
                <div className='mobile-notification__body'>
                    <div className='mobile-notification__body-heading'>Don’t miss out on this job opportunity!</div>
                    <div className='mobile-notification__body-description'>{job_title}</div>
                    <Button disabled={btnLoading} onClick={onContinue} colors={{ backgroundColor: '#2F6AE3', color: '#fff' }}>
                        Continue application {" "} {btnLoading && <span className='continue-spinner'><Spinner $color="#fff" $size={SIZE.small} /></span>}
                    </Button>
                </div>
            ) : (
                <div className='mobile-notification__body'>
                    <div className='mobile-notification__body-heading'>Don’t miss out on this job opportunity!</div>
                    <div className='mobile-notification__body-description'>{job_title}</div>
                    <Button onClick={onContinue} colors={{ backgroundColor: '#2F6AE3', color: '#fff' }}>
                        Apply now
                    </Button>
                </div>
            )}
        </div>
    )
}

MobileScrollNotification.propTypes = {
    auth: PropTypes.bool,
    btnLoading: PropTypes.bool,
    onContinue: PropTypes.bool,
    job_title: PropTypes.bool
}

export default MobileScrollNotification;